import { createFileRoute } from '@tanstack/react-router';
import { EnablementRoomPage } from '@/components/EnablementRoomPage';

export const Route = createFileRoute('/_authenticated/cuit-profiles/$id/enablement')({
  component: EnablementRoomRoute,
});

function EnablementRoomRoute(): JSX.Element {
  const { id } = Route.useParams();
  return <EnablementRoomPage id={id} />;
}
